// import "./chatting.css";
import moment from "moment";
import { useContext } from "react";
import TimeAgo from "timeago-react";
import { serverInfo } from "../../../../App";
// import { format } from "timeago.js";

export default function Message({ message, color, userInfo }) {
  const { imageCdnUrl } = useContext(serverInfo);
  return (
    <>


      <div
        className={
          userInfo?.id == message?.sender_id
            ? "message own"
            : "message"
        }
      >
        <div
          className={
            userInfo?.id == message?.sender_id
              ? "text-muted message-sender"
              : "text-muted message-receiver"
          }
        >
          {message.sender_name}
        </div>
        <div className="messageTop">
          <div className="d-flex flex-column justify-content-center">
            <img
              className="messageImg"
              src={imageCdnUrl + message?.sender_image}
              alt=""
            />
          </div>

          <p className="messageText">
            {message.text}
          </p>
        </div>
        <div className="messageBottom text-muted">
          {/* {Date(Date.now()).getDate()} */}
          {moment(message?.created_at).subtract(6, 'days').calendar()}
          {/* {message.time} */}
        </div>
      </div>
    </>
  );
}
